import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return <div className="shop main"><section className="products-grid">
          <div className="products-container">
            {productData.map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onClick={toTop}
              >
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-info">
                  <h4>{product.name}</h4>
                  <p className="price">£{product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section></div>;
}

export default Shop;
